import React from 'react';
import Page from '../../widgets/Page';
import UserProfileCard from './UserProfileCard';

const MyAccountComponent = () => (
  <Page title="My Account">
    <UserProfileCard />
  </Page>
);

export default MyAccountComponent;
